<template>
  <div>
    <!-- 验收 -->
    <PageAllow
      controller="Purchases"
      :action="isView ? 'view' : isFinish ? 'examine' : mode"
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <!-- 表格 -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("PurchasesDetail.ObjectName")]) }}
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="purchase.status | purchaseStatusColor"
                :text-color="purchase.status | purchaseStatusTextColor"
              >
                {{ purchase.status | purchaseStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <!-- 验收确认 -->
                <v-btn
                  v-if="isExamine"
                  small
                  dark
                  color="print"
                  class="px-2 me-2 mb-1"
                  @click.stop="submit()"
                >
                  <v-icon x-small class="pe-1">far fa-check-square</v-icon>
                  {{ $t("PurchasesList.actions.confirm") }}
                </v-btn>
                <!-- 验收完成 -->
                <v-btn
                  v-if="isFinish"
                  small
                  dark
                  color="print"
                  class="px-2 me-2 mb-1"
                  @click.stop="Examine()"
                >
                  <v-icon x-small class="pe-1">far fa-check-circle</v-icon>
                  {{ $t("PurchasesList.actions.finish") }}
                </v-btn>
              </v-sheet>
              <PurchasesActions
                v-if="isView"
                :purchase="purchase"
                showPrint
                :showLogistic="purchase.logistics_json != null"
                :showExamine="purchase.actions && purchase.actions.examine"
                :showFinish="purchase.actions && purchase.actions.over"
                showExamineExport
              />
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 采购单号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.purchase_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.purchase_code }}
                </v-card>
              </v-col>
              <!-- 创建时间 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.created")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 希望配送日 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.expect_date")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <SearcherDatetime
                    v-if="mode == 'examine' || editHopeDeliveryDate"
                    class="my-n2"
                    v-model="purchase.hope_delivery_date"
                    type="date"
                    single-line
                    dense
                    hide-details
                    :disabled-before-today="mode == 'examine'"
                  />
                  <span v-else>
                    {{ purchase.hope_delivery_date | formatDate }}
                  </span>
                  <v-icon
                    v-if="
                      purchase.status &&
                      mode != 'examine' &&
                      $permission.permissionAllow('Purchases', 'edit') &&
                      !editHopeDeliveryDate &&
                      purchase &&
                      purchase.status != 4 &&
                      purchase.status != 99
                    "
                    small
                    color="primary"
                    class="ml-5"
                    @click.stop="editHopeDeliveryDate = true"
                  >
                    fa-pencil-alt
                  </v-icon>
                  <v-icon
                    v-if="editHopeDeliveryDate"
                    small
                    color="primary"
                    class="ml-5"
                    @click.stop="
                      editHopeDeliveryDate = false;
                      editDate();
                    "
                  >
                    fa-check
                  </v-icon>
                  <v-icon
                    v-if="editHopeDeliveryDate"
                    small
                    color="primary"
                    class="ml-2"
                    @click.stop="
                      editHopeDeliveryDate = false;
                      purchase.hope_delivery_date = oldHopeDeliveryDate;
                    "
                  >
                    fa-times
                  </v-icon>
                </v-card>
              </v-col>
              <!-- 仓库 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.stock")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.stock ? purchase.stock.name : "" }}
                </v-card>
              </v-col>
              <!-- 供应商 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.supplier_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.supplier ? purchase.supplier.supplier_name : "" }}
                </v-card>
              </v-col>
              <!-- 采购单来源 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.origin_flg")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ purchase.origin_flg | originFlgsText }}
                </v-card>
              </v-col>
              <!-- 创建者 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.creater")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase.creater_name }}
                  </span>
                </v-card>
              </v-col>
              <!-- 第三方单号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.purchase")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase.ext_code }}
                  </span>
                </v-card>
              </v-col>
              <!-- 要货单单号 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <a
                    class="text-no-wrap"
                    :href="'/#/orders/' + purchase.order_id"
                    style="text-decoration: none"
                  >
                    {{ purchase.order_code }}
                  </a>
                </v-card>
              </v-col>
              <!-- 收货人 -->
              <v-col
                cols="12"
                md="4"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.receiver_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      purchase.delivery_info
                        ? purchase.delivery_info.receiver_name
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 联系方式 -->
              <v-col
                cols="12"
                md="8"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.receiver_phone")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      purchase.delivery_info
                        ? purchase.delivery_info.receiver_phone
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 收货地址 -->
              <v-col
                cols="12"
                md="12"
                v-if="settings && settings.show_purchase_address"
              >
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.receiver_address")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{
                      purchase.delivery_info
                        ? purchase.delivery_info.receiver_province +
                          purchase.delivery_info.receiver_city +
                          purchase.delivery_info.receiver_area +
                          purchase.delivery_info.receiver_address
                        : ""
                    }}
                  </span>
                </v-card>
              </v-col>
              <!-- 备注 -->
              <v-col cols="12" sm="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.memo")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ purchase.memo }}
                  </span>
                </v-card>
              </v-col>
              <!-- 附件 -->
              <v-col cols="12" sm="12" md="12">
                <v-card
                  class="pa-2 d-flex overflow-auto text-no-wrap"
                  outlined
                  tile
                >
                  <span class="secondary--text">
                    {{ $t("PurchasesDetail.Fields.attachments")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <!-- 上传图片集 -->
                  <span class="ml-4">
                    <v-card
                      height="160"
                      width="240"
                      v-if="album && album.length > 0"
                    >
                      <v-carousel
                        hide-delimiters
                        cycle
                        height="160"
                        width="240"
                      >
                        <v-carousel-item
                          v-for="(item, i) in album"
                          :key="i"
                          :src="item"
                          @click.stop="$showFullscreenImages(album, i)"
                        >
                          <!-- <v-tooltip right v-if="savable && item">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="removeFromImages(i)"
                                v-if="isNew"
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span> {{ $t("Material.delImg") }}</span>
                          </v-tooltip> -->
                        </v-carousel-item>
                      </v-carousel>
                    </v-card>
                    <v-file-input
                      ref="imgs_file"
                      v-show="savable"
                      show-size
                      counter
                      small-chips
                      multiple
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgsRules"
                      v-model="imgs_file"
                    >
                    </v-file-input>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- 活动记录 -->
        <v-expansion-panel>
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab
                @click.stop="
                  tab = 0;
                  panels.indexOf(1) == -1 ? panels.push(1) : '';
                "
              >
                {{ $t("PurchasesDetail.activities.title") }}
              </v-tab>
              <v-tab
                @click.stop="
                  tab = 1;
                  panels.indexOf(1) == -1 ? panels.push(1) : '';
                "
              >
                {{ $t("PurchasesDetail.activities.receipt") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <!-- 活动记录 -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="activities_details"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                  </v-data-table>
                </v-card>
              </v-tab-item>
              <!-- 相关入库单据 -->
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="stockInsHeaders"
                    :items="stockIns_details"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.stock_name>
                      {{ purchase.stock.name }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        small
                        label
                        class="ms-4 mt-1"
                        :color="purchase.status | stockOrderINStatusColor"
                        :text-color="
                          purchase.status | stockOrderINStatusTextColor
                        "
                      >
                        {{ item.status | stockOrderINStatusText }}
                      </v-chip>
                    </template>
                    <template v-slot:item.created="{ item }">
                      {{ item.created | formatTime }}
                    </template>
                    <template v-slot:item.finish_time="{ item }">
                      {{ item.finish_time | formatTime }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        dark
                        color="info"
                        class="px-2 me-2 mb-1"
                        :href="'/#/stock-orders-in/' + item.id"
                      >
                        <v-icon x-small class="pe-1">fa-align-left</v-icon>
                        {{ $t("PurchasesList.actions.detail") }}
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- 明细 -->
      <v-data-table
        id="details_table"
        :headers="headers"
        :items="purchaseDetails"
        multi-sort
        disable-pagination
        hide-default-footer
        class="elevation-2 px-4 mt-4 pb-4"
        :show-expand="(
          isExamine &&
          !purchase.delivery_date &&
          settings &&
          settings.product_date_setting) ? true :false"
        :expanded.sync="expanded"
        style="border-collapse: collapse"
        :search="filter"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("PurchasesDetail.ObjectName")]) }}
            </v-toolbar-title>
            <v-spacer />
            <v-col v-if="isView && purchase.supplier && purchase.supplier.type == 2" cols="12" sm="2" md="2" class="align-end text-end">
              {{ $t("PurchasesDetail.express_price") }}
              {{ $t("Global.colon") }}
              <span class="danger--text">
                  {{ $t("Global.money") }}
                  {{ purchase.express_price | formatMoney }}
                </span>
            </v-col>
            <span v-if="isView" class="py-0 subtitle-1 d-inline-block">
              {{ $t("PurchasesDetail.price_total") }}
              {{ $t("Global.colon") }}
              <span class="danger--text">
                {{ $t("Global.money") }}
                {{
                  purchase.status == 3 || purchase.status == 4
                    ? purchase.total
                    : purchase.quantity_price_total | formatMoney
                }}
              </span>
            </span>
          </v-toolbar>
          <v-divider />
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <v-row no-gutters class="me-n3">
              <span class="caption secondary--text pt-2">
                {{
                  $t(
                    "$vuetify.dataFooter.pageText",
                    purchase_details
                      ? [1, purchase_details.length, purchase_details.length]
                      : [0, 0, 0]
                  )
                }}
              </span>
              <v-row no-gutters>
                <v-spacer />
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="filter"
                    clearable
                    hide-details
                    :label="$t('Search.filter')"
                  />
                </v-col>
              </v-row>
            </v-row>
          </v-toolbar>
        </template>
        <!-- 操作 -->
        <template v-slot:header.examine_num_edit="{ header }">
          {{ header.text }}
          <br />
          <v-btn
            v-if="!purchase.NoPartExamineFlg && purchase.status == 2"
            text
            small
            class="text-no-wrap caption secondary--text"
            :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
            @click.stop="fillExamineNum()"
          >
            {{ $t("PurchasesDetail.purchaseFields.fill") }}
          </v-btn>
        </template>
        <!-- 操作 -->
        <template v-slot:header.data-table-expand="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.material_name="{ item }">
            {{ item.material_name
            }}<v-icon
              small
              light
              class="pe-1 ml-1"
              color="primary"
              @click.stop="dialogMaterialID = item.material_id"
              >fa-info-circle</v-icon
            >
          </template>
        <template v-slot:item.standard_name="{ item }">
          <span
            v-if="item.standard_name && item.standard_name.length > 12"
            :title="item.standard_name"
            style="cursor: pointer"
          >
            {{ item.standard_name.slice(0, 12) + "......" }}
          </span>
          <span v-else>
            {{ item.standard_name ? item.standard_name : "" }}
          </span>
        </template>
        <template v-slot:item.before_tax_price="{ item }">
          <span class="text-no-wrap">
            {{ $t("Global.money")
            }}{{ item.before_tax_price | formatWithDot(3) }}
          </span>
        </template>
        <template v-slot:item.after_tax_price="{ item }">
          <span class="text-no-wrap">
            {{ $t("Global.money") }}
            {{ item.after_tax_price | formatWithDot(3) }}
          </span>
        </template>
        <template v-slot:item.examine_num_edit="{ item }">
          <NumberInput v-if="isExamine" v-model="item.examine_num_edit" dense />
        </template>
        <!-- 单价 -->
        <template v-slot:item.price="{ item }">
          <span v-if="item.negotiate_price_flg == 1">
            {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
          </span>
          <span v-else>
            <v-text-field
              v-if="isExamine && settings && settings.purchase_subtotal != 1"
              v-model="item.price"
              :placeholder="
                String($numberFormatter.formatMoneyFloor(item.price, 2))
              "
              single-line
              dense
              hide-details
              type="number"
              min="0"
              :prefix="$t('Global.money')"
              @blur="
                item.price = $numberFormatter.formatMoneyFloor(item.price, 2)
              "
              style="max-width: 80px; margin-left: auto"
            />
            <span v-else>
              {{ $t("Global.money") }}{{ item.price | formatTwoDot }}
            </span>
          </span>
        </template>
        <!-- 采购订货数 -->
        <template v-slot:item.quantity="{ item }">
          {{ item.quantity | formatTwoDot }}{{ item.unit }}
        </template>
        <!-- 基准订货数 -->
        <template v-slot:item.default_quantity="{ item }">
          {{ item.default_quantity | formatTwoDot }}{{ item.default_unit }}
        </template>
        <template v-slot:item.before_tax_total="{ item }">
          {{ $t("Global.money") }}
          {{ item.before_tax_total | formatTwoDot }}
        </template>
        <template v-slot:item.after_tax_total="{ item }">
          {{ $t("Global.money") }}
          {{ item.after_tax_total | formatTwoDot }}
        </template>
        <template v-slot:item.total="{ item }">
          <span v-if="item.negotiate_price_flg == 1">
            {{ $t("PurchasesDetail.purchaseFields.negotiatePrices") }}
          </span>
          <span v-else>
            <v-text-field
              v-if="isExamine && settings && settings.purchase_subtotal == 1"
              v-model="item.total"
              :placeholder="
                String($numberFormatter.formatMoneyFloor(item.total, 2))
              "
              single-line
              dense
              hide-details
              type="number"
              min="0"
              :prefix="$t('Global.money')"
              @blur="
                item.total = $numberFormatter.formatMoneyFloor(item.total, 2)
              "
              style="max-width: 80px; margin-left: auto"
            />
            <span v-else>
              {{ $t("Global.money") }}{{ item.total | formatTwoDot }}
            </span>
          </span>
        </template>
        <template v-slot:item.examine_num="{ item }">
          {{ item.examine_num | formatTwoDot }}
        </template>
        <template v-slot:item.default_examine_num="{ item }">
          {{ item.default_examine_num | formatTwoDot }}
        </template>
        <!-- 生产日期 -->
        <template v-slot:item.production_date="{ item }">
          <SearcherDatetime
            v-if="isExamine"
            class="my-n2"
            v-model="item.production_date"
            type="date"
            single-line
            dense
            hide-details
            :required="
              (item.bestbefore && Number(item.bestbefore) > 0) ||
              settings.material_force_bestbefore == 1
            "
            disabledAfterNow
          />
          <span v-else>
            {{ item.production_date | formatDate }}
          </span>
        </template>
        <!-- 过期日期 -->
        <template v-slot:item.expire_date="{ item }">
          <SearcherDatetime
            v-if="isExamine"
            class="my-n2"
            v-model="item.expired_date"
            type="date"
            single-line
            dense
            hide-details
            :required="
              (item.bestbefore && Number(item.bestbefore) > 0) ||
              settings.material_force_bestbefore == 1
            "
            disabledBeforeToday
          />
          <span v-else>
            {{ item.expired_date | formatDate }}
          </span>
        </template>
        <!-- 备注 -->
        <template v-slot:item.examine_memo="{ item }">
          <v-text-field
            v-if="isExamine"
            v-model="item.examine_memo"
            single-line
            dense
            hide-details
            style="max-width: 120px"
          >
            <template v-slot:append>
              <v-icon
                x-small
                @click.stop="
                  detail_memo_item = item;
                  memo_idx = 1;
                  memo_dialog = true;
                "
                class="pt-2 pb-1 primary--text"
              >
                fa-edit
              </v-icon>
            </template>
          </v-text-field>
          <span v-else>
            {{ item.examine_memo }}
          </span>
        </template>
        <template v-slot:item.qualify_report_img="{ item }">
          <!-- 质检报告 -->
          <v-btn
            v-if="isExamine"
            :color="
              item &&
              ((item.qualify_report_img &&
                item.qualify_report_img.length > 0) ||
                (item.qualify_report_img_url &&
                  item.qualify_report_img_url.length > 0))
                ? 'orange'
                : 'primary'
            "
            style="color: white"
            class="my-1"
            small
            @click.stop="
              currentItem = item;
              qualifyReportDialog = true;
            "
          >
            {{ $t("PurchasesDetail.purchaseFields.qualify_report") }}
          </v-btn>
        </template>
        <!-- expend扩展行 -->
        <template v-slot:expanded-item="{ item }">
          <td colspan="7" class="pa-0">
            <div style="height: 50px"></div>
            <v-divider />
            <div style="height: 50px"></div>
          </td>
          <td class="pa-0">
            <div style="height: 50px" class="pa-3">
              <NumberInput v-model="item.examine_num_edit_2" dense />
            </div>
            <v-divider />
            <div style="height: 50px" class="pa-3">
              <NumberInput v-model="item.examine_num_edit_3" dense />
            </div>
          </td>
          <td
            class="pa-0"
            v-if="isExamine && settings && settings.purchase_subtotal == 1"
          >
            <div style="height: 50px">
              <div style="line-height: 50px; text-align: center">
                {{ $t("Global.money") }}{{ item.price_2 | formatTwoDot }}
              </div>
            </div>
            <v-divider />
            <div style="height: 50px">
              <div style="line-height: 50px; text-align: center">
                {{ $t("Global.money") }}{{ item.price_3 | formatTwoDot }}
              </div>
            </div>
          </td>
          <td
            class="pa-0"
            v-if="isExamine && settings && settings.purchase_subtotal == 1"
          >
            <div style="height: 50px" class="pa-3">
              <v-text-field
                v-model="item.total_2"
                :placeholder="
                  String($numberFormatter.formatMoneyFloor(item.total, 2))
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.total_2 = $numberFormatter.formatMoneyFloor(
                    item.total_2,
                    2
                  )
                "
                style="max-width: 80px; margin-left: auto"
              />
            </div>
            <v-divider />
            <div style="height: 50px" class="pa-3">
              <v-text-field
                v-model="item.total_3"
                :placeholder="
                  String($numberFormatter.formatMoneyFloor(item.total, 2))
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.total_3 = $numberFormatter.formatMoneyFloor(
                    item.total_3,
                    2
                  )
                "
                style="max-width: 80px; margin-left: auto"
              />
            </div>
          </td>
          <td
            class="pa-0"
            v-if="isExamine && settings && !settings.purchase_subtotal"
          >
            <div style="height: 50px" class="pa-3">
              <v-text-field
                v-model="item.price_2"
                :placeholder="
                  String($numberFormatter.formatMoneyFloor(item.price, 2))
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price_2 = $numberFormatter.formatMoneyFloor(
                    item.price_2,
                    2
                  )
                "
                style="max-width: 80px; margin-left: auto"
              />
            </div>
            <v-divider />
            <div style="height: 50px" class="pa-3">
              <v-text-field
                v-model="item.price_3"
                :placeholder="
                  String($numberFormatter.formatMoneyFloor(item.price, 2))
                "
                single-line
                dense
                hide-details
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.price_3 = $numberFormatter.formatMoneyFloor(
                    item.price_3,
                    2
                  )
                "
                style="max-width: 80px; margin-left: auto"
              />
            </div>
          </td>
          <td
            class="pa-0"
            v-if="isExamine && settings && settings.purchase_subtotal == 0"
          >
            <div style="height: 50px">
              <div style="line-height: 50px; text-align: center">
                {{ $t("Global.money") }}{{ item.total_2 | formatTwoDot }}
              </div>
            </div>
            <v-divider />
            <div style="height: 50px">
              <div style="line-height: 50px; text-align: center">
                {{ $t("Global.money") }}{{ item.total_3 | formatTwoDot }}
              </div>
            </div>
          </td>
          <td class="pa-0" v-if="settings && settings.product_date_setting">
            <div style="height: 50px" class="pa-3">
              <SearcherDatetime
                v-model="item.production_date_2"
                type="date"
                single-line
                dense
                hide-details
                :required="
                  (item.bestbefore && Number(item.bestbefore) > 0) ||
                  settings.material_force_bestbefore == 1
                "
                disabledAfterNow
              />
            </div>
            <v-divider />
            <div style="height: 50px" class="pa-3">
              <SearcherDatetime
                v-model="item.production_date_3"
                type="date"
                single-line
                dense
                hide-details
                :required="
                  (item.bestbefore && Number(item.bestbefore) > 0) ||
                  settings.material_force_bestbefore == 1
                "
                disabledAfterNow
              />
            </div>
          </td>
          <td class="pa-0" v-if="settings && settings.product_date_setting">
            <div style="height: 50px" class="pa-3">
              <SearcherDatetime
                v-model="item.expired_date_2"
                type="date"
                single-line
                dense
                hide-details
                :required="
                  (item.bestbefore && Number(item.bestbefore) > 0) ||
                  settings.material_force_bestbefore == 1
                "
                disabledBeforeToday
              />
            </div>
            <v-divider />
            <div style="height: 50px" class="pa-3">
              <SearcherDatetime
                v-model="item.expired_date_3"
                type="date"
                single-line
                dense
                hide-details
                :required="
                  (item.bestbefore && Number(item.bestbefore) > 0) ||
                  settings.material_force_bestbefore == 1
                "
                disabledBeforeToday
              />
            </div>
          </td>
          <td class="pa-0">
            <div style="height: 50px" class="pa-3">
              <v-text-field
                v-model="item.examine_memo_2"
                single-line
                dense
                hide-details
                style="max-width: 120px"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="
                      detail_memo_item = item;
                      memo_idx = 2;
                      memo_dialog = true;
                    "
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
            </div>
            <v-divider />
            <div style="height: 50px" class="pa-3">
              <v-text-field
                v-model="item.examine_memo_3"
                single-line
                dense
                hide-details
                style="max-width: 120px"
              >
                <template v-slot:append>
                  <v-icon
                    x-small
                    @click.stop="
                      detail_memo_item = item;
                      memo_idx = 3;
                      memo_dialog = true;
                    "
                    class="pt-2 pb-1 primary--text"
                  >
                    fa-edit
                  </v-icon>
                </template>
              </v-text-field>
            </div>
          </td>
          <td
            class="pa-0"
            v-if="
              isExamine &&
              !purchase.NoPartExamineFlg &&
              settings &&
              settings.qualify_report_enable == 1
            "
          >
            <!-- 质检报告 -->
            <div style="height: 50px" class="pa-3">
              <v-btn
                :color="
                  item &&
                  item.qualify_report_img_2 &&
                  item.qualify_report_img_2.length > 0
                    ? 'orange'
                    : 'primary'
                "
                style="color: white"
                class="my-1"
                small
                @click.stop="
                  currentItem = item;
                  qualifyReportDialog_2 = true;
                "
              >
                {{ $t("PurchasesDetail.purchaseFields.qualify_report") }}
              </v-btn>
            </div>
            <v-divider />
            <div style="height: 50px" class="pa-3">
              <v-btn
                :color="
                  item &&
                  item.qualify_report_img_3 &&
                  item.qualify_report_img_3.length > 0
                    ? 'orange'
                    : 'primary'
                "
                style="color: white"
                class="my-1"
                small
                @click.stop="
                  currentItem = item;
                  qualifyReportDialog_3 = true;
                "
              >
                {{ $t("PurchasesDetail.purchaseFields.qualify_report") }}
              </v-btn>
            </div>
          </td>
          <td class="pa-0">
            <div style="height: 50px"></div>
            <v-divider />
            <div style="height: 50px"></div>
          </td>
        </template>
      </v-data-table>
    </v-sheet>

    <v-dialog v-model="memo_dialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{
              $t("Material.materialNameWithCode", [
                detail_memo_item.material_code,
                detail_memo_item.material_name,
              ])
            }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="memo_dialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 pt-8">
          <v-textarea
            v-if="memo_idx == 1"
            v-model="detail_memo_item.examine_memo"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
          <v-textarea
            v-if="memo_idx == 2"
            v-model="detail_memo_item.examine_memo_2"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
          <v-textarea
            v-if="memo_idx == 3"
            v-model="detail_memo_item.examine_memo_3"
            outlined
            :label="$t('Order.DetailFields.memo')"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="memo_dialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogPostImages
      v-model="qualifyReportDialog"
      @addComfirm="setQualifyReportImg('qualify_report_img', $event)"
      :img_url="
        currentItem &&
        currentItem.qualify_report_img &&
        currentItem.qualify_report_img.length > 0 &&
        currentItem.qualify_report_img[0].img_name
          ? currentItem.qualify_report_img
          : currentItem &&
            currentItem.qualify_report_img_url &&
            currentItem.qualify_report_img_url.length > 0
          ? currentItem.qualify_report_img_url
          : []
      "
      :editEnable="isExamine"
    />
    <DialogPostImages
      v-model="qualifyReportDialog_2"
      @addComfirm="currentItem.qualify_report_img_2 = $event"
      :img_url="
        currentItem &&
        currentItem.qualify_report_img_2 &&
        currentItem.qualify_report_img_2.length > 0
          ? currentItem.qualify_report_img_2
          : []
      "
      :editEnable="isExamine"
    />
    <DialogPostImages
      v-model="qualifyReportDialog_3"
      @addComfirm="currentItem.qualify_report_img_3 = $event"
      :img_url="
        currentItem &&
        currentItem.qualify_report_img_3 &&
        currentItem.qualify_report_img_3.length > 0
          ? currentItem.qualify_report_img_3
          : []
      "
      folder_type="images"
      :title="$t('PurchasesDetail.purchaseFields.qualify_report')"
      :editEnable="isExamine"
    />
    <DialogDateError v-model="dateErrorDialog" :errorData="dateErrorData" />
    <MaterialDialog v-model="dialogMaterialID" showOrderUnitInfo/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import NumberInput from "@/components/plugins/NumberInput";
import PurchasesActions from "./plugins/Actions";
import Purchases from "@/api/purchases";
import DialogPostImages from "@/components/plugins/DialogPostImages";
// import DialogImages from "@/components/plugins/DialogImages";
import Files from "@/api/files";
import DialogDateError from "@/components/plugins/DialogDateError";
import MaterialDialog from "@/components/materials/plugins/Dialog";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetime,
    NumberInput,
    PurchasesActions,
    DialogPostImages,
    // DialogImages,
    DialogDateError,
    MaterialDialog,
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    isExamine() {
      return this.mode == "examine";
    },
    isFinish() {
      return this.mode == "finish";
    },
    savable() {
      return !this.preview && (this.mode == "examine" || this.mode == "finish");
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: this.isView
            ? i18n.t("Nav.purchasesExamineDetail")
            : this.isExamine
            ? i18n.t("Nav.purchasesExamine")
            : i18n.t("Nav.purchasesExamineDetail"),
          disabled: true,
          href: "/purchases-examine",
        },
      ];
      if (this.purchase && this.purchase.purchase_code) {
        items.push({
          text: this.purchase.purchase_code,
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    headers() {
      var headers = [
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.supply_code"),
          align: "start",
          sortable: false,
          value: "supply_code",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.standard_name"),
          align: "start",
          sortable: false,
          value: "standard_name",
        },
      ];
      if (
        this.settings &&
        this.settings.use_tax == 1 &&
        (this.isView || this.isFinish)
      ) {
        headers.push(
          //商品税率
          {
            text: i18n.t("PurchasesDetail.purchaseFields.tax_rate"),
            align: "end",
            sortable: false,
            value: "tax_rate",
          },
          //     单价 不含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.before_tax_price"),
            align: "end",
            sortable: false,
            value: "before_tax_price",
          },
          //   单价 含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.after_tax_price"),
            align: "end",
            sortable: false,
            value: "after_tax_price",
          }
        );
      } else if (
        this.settings &&
        this.settings.use_tax == 0 &&
        (this.isView || this.isFinish)
      ) {
        headers.push(
          //   单价
          {
            text: i18n.t("PurchasesDetail.purchaseFields.price"),
            align: "end",
            sortable: false,
            value: "price",
          }
        );
      }

      headers.push(
        {
          text: i18n.t("PurchasesDetail.purchaseFields.quantity"),
          align: "end",
          sortable: false,
          value: "quantity",
        },
        {
          text: i18n.t("PurchasesDetail.purchaseFields.default_quantity"),
          align: "end",
          sortable: false,
          value: "default_quantity",
        }
      );

      if (
        this.settings &&
        this.settings.use_tax == 1 &&
        (this.isView || this.isFinish)
      ) {
        headers.push(
          //   采购金额 不含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.before_tax_total"),
            align: "end",
            sortable: false,
            value: "before_tax_total",
          },
          //   采购金额 含税
          {
            text: i18n.t("PurchasesDetail.purchaseFields.after_tax_total"),
            align: "end",
            sortable: false,
            value: "after_tax_total",
          }
        );
      } else if (
        this.settings &&
        this.settings.use_tax == 0 &&
        (this.isView || this.isFinish)
      ) {
        headers.push(
          // 采购金额
          {
            text: i18n.t("PurchasesDetail.purchaseFields.total"),
            align: "center",
            sortable: false,
            value: "total",
          }
        );
      }

      if (this.isView || this.isFinish) {
        headers.push(
          {
            text: i18n.t("PurchasesDetail.purchaseFields.stock_in_num"),
            align: "end",
            sortable: false,
            value: "examine_num",
          },
          {
            text: i18n.t("PurchasesDetail.purchaseFields.default_stock_in_num"),
            align: "end",
            sortable: false,
            value: "default_examine_num",
          }
        );
      } else if (this.isExamine) {
        headers.push(
          {
            text: this.purchase.NoPartExamineFlg
              ? i18n.t("PurchasesDetail.purchaseFields.delivered_num")
              : i18n.t("PurchasesDetail.purchaseFields.examined_num"),
            align: "end",
            sortable: false,
            value: "examine_num",
          },
          {
            text: i18n.t("PurchasesDetail.purchaseFields.examine_num"),
            align: "center",
            sortable: false,
            value: "examine_num_edit",
          },
          {
            text: i18n.t("PurchasesDetail.purchaseFields.examine_price"),
            align: "center",
            sortable: false,
            value: "price",
          },
          {
            text: i18n.t("PurchasesDetail.purchaseFields.total"),
            align: "center",
            sortable: false,
            value: "total",
          }
        );
      }

      if (
        this.settings &&
        this.settings.product_date_setting == 1 &&
        this.isExamine
      ) {
        headers.push(
          {
            text: i18n.t("PurchasesDetail.purchaseFields.production_date"),
            align: "start",
            sortable: false,
            value: "production_date",
          },
          {
            text: i18n.t("PurchasesDetail.purchaseFields.expire_date"),
            align: "start",
            sortable: false,
            value: "expire_date",
          }
        );
      }

      headers.push({
        text: i18n.t("PurchasesDetail.purchaseFields.examine_memo"),
        align: "start",
        sortable: false,
        value: "examine_memo",
      });
      if (
        this.isExamine &&
        this.settings &&
        this.settings.qualify_report_enable == 1
      ) {
        headers.push({
          text: i18n.t("PurchasesDetail.purchaseFields.qualify_report"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "qualify_report_img",
        });
      }

      if (
        this.isExamine &&
        !this.purchase.delivery_date &&
        this.settings &&
        this.settings.product_date_setting
      ) {
        headers.push({
          text: "",
          align: "start",
          sortable: false,
          value: "data-table-expand",
        });
      }

      return headers;
    },

    activitiesHeaders: () => [
      {
        text: i18n.t("PurchasesDetail.activities.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("PurchasesDetail.activities.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("PurchasesDetail.activities.operater"),
        align: "start",
        sortable: false,
        value: "operater.name",
      },
    ],
    stockInsHeaders: () => [
      {
        text: i18n.t("PurchasesDetail.stockIns.stock_order_code"),
        align: "start",
        sortable: false,
        value: "stock_order_code",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.stock_name"),
        align: "start",
        sortable: false,
        value: "stock_name",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.creater"),
        align: "start",
        sortable: false,
        value: "creater_name",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("PurchasesDetail.stockIns.finish_time"),
        align: "start",
        sortable: false,
        value: "finish_time",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    purchaseDetails() {
      if (this.isExamine) {
        let item = [];
        if (this.purchase_details) {
          this.purchase_details.forEach((detail) => {
            if (
              this.purchase.delivery_flg == 1 &&
              this.purchase.delivery_date &&
              detail.stock_in_details &&
              detail.stock_in_details.length >= 1
            ) {
              // detail.stock_in_details && detail.stock_in_details.length >= 1
              detail.stock_in_details.forEach((stockDetail) => {
                stockDetail.tax_rate = detail.tax_rate;
                stockDetail.before_tax_price = detail.before_tax_price;
                stockDetail.after_tax_price = detail.after_tax_price;
                stockDetail.price = detail.price;
                stockDetail.quantity = detail.quantity;
                stockDetail.default_quantity = detail.default_quantity;
                stockDetail.examine_num = stockDetail.order_num;
                stockDetail.examine_num_edit =
                  this.purchase.status == 3 ? "" : stockDetail.order_num;
                stockDetail.total = detail.total;
                item.push(stockDetail);
              });
            } else {
              item.push(detail);
            }
          });
        }
        return item;
      } else {
        return this.purchase_details;
      }
    },

    ...mapState(["settings", "accountUser"]),
  },

  data: () => ({
    expanded: [],
    serverErrors: [],
    selectShopErrors: [],
    stocks: {},
    suppliers: {},
    panels: [0],
    tab: null,
    mode: "",
    purchase: {},
    purchase_details: [],
    activities_details: [],
    detail_memo_item: { memo: "" },
    memo_idx: 1,
    memo_dialog: false,
    preview: false,
    orderBeforPreview: [],
    stockIns_details: [],
    qualifyReportDialog: false,
    qualifyReportDialog_2: false,
    qualifyReportDialog_3: false,
    currentItem: null,
    editHopeDeliveryDate: false,
    oldHopeDeliveryDate: "",
    album: [],
    imgs_file: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    dateErrorData: [],
    dateErrorDialog: false,
    filter: "",
    dialogMaterialID: null,
    editExpressFlg: false,
  }),

  mounted() {
    this.mode = this.$route.params.mode;
    if (this.mode)
      this.$router.replace("/purchases-examine/" + this.$route.params.id);
  },

  methods: {
    getPurchasesDetailsFromAPI() {
      Purchases.fetchExamineDetail(this.$route.params.id, {
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchase = response.data.purchase;
            this.oldHopeDeliveryDate =
              response.data.purchase.hope_delivery_date;
            this.purchase_details = response.data.purchase.purchase_details.map(
              (detail) => {
                detail.price = this.$numberFormatter.formatMoney(
                  detail.price,
                  2
                );
                if (this.isExamine) {
                  if (this.purchase.NoPartExamineFlg) {
                    detail = Object.assign({}, detail, {
                      examine_num_edit: detail.examine_num,
                    });
                    // detail.examine_num_edit = detail.examine_num;
                  }
                  if (!detail.examine_memo) {
                    detail.examine_memo = detail.memo;
                  }
                  //部分验收时初始化生产日期过期日期
                  if (this.purchase.status == 3) {
                    detail.expired_date = "";
                    detail.production_date = "";
                  }

                  if (
                    this.purchase.delivery_flg == 1 &&
                    this.purchase.delivery_date
                  ) {
                    if (detail.stock_in_details) {
                      detail.stock_in_details.forEach((stockDetail) => {
                        this.$set(
                          stockDetail,
                          "examine_num_edit",
                          stockDetail.order_num
                        );
                        this.$set(stockDetail, "price", detail.price);
                        this.$set(
                          stockDetail,
                          "total",
                          Number(stockDetail.examine_num_edit) *
                            Number(stockDetail.price)
                        );
                      });
                    }
                    return detail;
                  } else {
                    let new_detail = Object.assign({}, detail, {
                      examine_num_edit_2: "",
                      examine_num_edit_3: "",
                      price_2: detail.price,
                      price_3: detail.price,
                      total_2: detail.total,
                      total_3: detail.total,
                      production_date_2: "",
                      production_date_3: "",
                      expired_date_2: "",
                      expired_date_3: "",
                      memo_2: "",
                      memo_3: "",
                      qualify_report_img: [],
                      qualify_report_img_2: [],
                      qualify_report_img_3: [],
                    });
                    return new_detail;
                  }
                } else {
                  return detail;
                }
              }
            );
            this.activities_details = response.data.order_activities;
            this.stockIns_details = response.data.stock_ins;
            this.album = response.data.purchase.img;
          }
        }.bind(this)
      );
    },
    fillExamineNum() {
      this.purchase_details = this.purchase_details.map((e) => {
        e = Object.assign({}, e, { examine_num_edit: Number(e.quantity) });
        // e.examine_num_edit = Number(e.quantity); // 采购数赋值到输入框
        return e;
      });
    },
    async submit() {
      this.$store.dispatch("fullscreenLoading");
      var data = [];
      if (this.purchase.delivery_flg == 1 && this.purchase.delivery_date) {
        // 供应商发货 or 部分验收 数据整理
        this.purchase_details.map((detail) => {
          if (detail.stock_in_details) {
            detail.stock_in_details.forEach((stockDetail) => {
              if (this.settings && this.settings.product_date_setting) {
                data.push({
                  id: detail.id,
                  stock_in_detail_id: stockDetail.id,
                  prices: stockDetail.price,
                  total: stockDetail.total,
                  memo: stockDetail.memo,
                  expired_date: stockDetail.expired_date,
                  production_date: stockDetail.production_date,
                  examine_num: stockDetail.examine_num_edit,
                  qualify_report_img:
                    stockDetail.qualify_report_img &&
                    stockDetail.qualify_report_img.length > 0 &&
                    stockDetail.qualify_report_img[0].img_name
                      ? stockDetail.qualify_report_img.map(
                          (img) => img.img_name
                        )
                      : stockDetail.qualify_report_img_arr &&
                        stockDetail.qualify_report_img_arr.length
                      ? stockDetail.qualify_report_img_arr.map(
                          (img) => img.img_name
                        )
                      : [], //质检报告
                });
              } else {
                data.push({
                  id: detail.id,
                  stock_in_detail_id: stockDetail.id,
                  prices: stockDetail.price,
                  total: stockDetail.total,
                  memo: stockDetail.memo,
                  examine_num: stockDetail.examine_num_edit,
                  qualify_report_img:
                    stockDetail.qualify_report_img &&
                    stockDetail.qualify_report_img.length > 0 &&
                    stockDetail.qualify_report_img[0].img_name
                      ? stockDetail.qualify_report_img.map(
                          (img) => img.img_name
                        )
                      : stockDetail.qualify_report_img_arr &&
                        stockDetail.qualify_report_img_arr.length
                      ? stockDetail.qualify_report_img_arr.map(
                          (img) => img.img_name
                        )
                      : [], //质检报告
                });
              }
            });
          }
        });
      } else {
        // 普通验收数据整理
        this.purchase_details.map((detail) => {
          if (detail.examine_num_edit > 0 || detail.examine_num_edit === 0) {
            if (this.settings && this.settings.product_date_setting) {
              data.push({
                id: detail.id,
                prices: detail.price,
                total: detail.total,
                memo: detail.memo,
                expired_date: detail.expired_date,
                production_date: detail.production_date,
                examine_num: detail.examine_num_edit,
                qualify_report_img:
                  detail.qualify_report_img && detail.qualify_report_img.length
                    ? detail.qualify_report_img.map((img) => img.img_name)
                    : [], //质检报告
              });
            } else {
              data.push({
                id: detail.id,
                prices: detail.price,
                total: detail.total,
                memo: detail.memo,
                examine_num: detail.examine_num_edit,
                qualify_report_img:
                  detail.qualify_report_img && detail.qualify_report_img.length
                    ? detail.qualify_report_img.map((img) => img.img_name)
                    : [],
              });
            }
          }

          if (
            detail.examine_num_edit_2 > 0 ||
            detail.examine_num_edit_2 === 0
          ) {
            if (this.settings && this.settings.product_date_setting) {
              data.push({
                id: detail.id,
                prices: detail.price_2,
                total: detail.total_2,
                examine_num: detail.examine_num_edit_2,
                memo: detail.memo_2,
                expired_date: detail.expired_date_2,
                production_date: detail.production_date_2,
                qualify_report_img:
                  detail.qualify_report_img_2 &&
                  detail.qualify_report_img_2.length
                    ? detail.qualify_report_img_2.map((img) => img.img_name)
                    : [],
              });
            } else {
              data.push({
                id: detail.id,
                prices: detail.price_2,
                total: detail.total_2,
                memo: detail.memo_2,
                examine_num: detail.examine_num_edit_2,
                qualify_report_img:
                  detail.qualify_report_img_2 &&
                  detail.qualify_report_img_2.length
                    ? detail.qualify_report_img_2.map((img) => img.img_name)
                    : [],
              });
            }
          }
          if (
            detail.examine_num_edit_3 > 0 ||
            detail.examine_num_edit_3 === 0
          ) {
            if (this.settings && this.settings.product_date_setting) {
              data.push({
                id: detail.id,
                prices: detail.price_3,
                total: detail.total_3,
                examine_num: detail.examine_num_edit_3,
                memo: detail.memo_3,
                expired_date: detail.expired_date_3,
                production_date: detail.production_date_3,
                qualify_report_img:
                  detail.qualify_report_img_3 &&
                  detail.qualify_report_img_3.length
                    ? detail.qualify_report_img_3.map((img) => img.img_name)
                    : [],
              });
            } else {
              data.push({
                id: detail.id,
                prices: detail.price_3,
                total: detail.total_3,
                memo: detail.memo_3,
                examine_num: detail.examine_num_edit_3,
                qualify_report_img:
                  detail.qualify_report_img_3 &&
                  detail.qualify_report_img_3.length
                    ? detail.qualify_report_img_3.map((img) => img.img_name)
                    : [],
              });
            }
          }
        });
      }
      if (data.length) {
        await this.submitUploadImg();
        Purchases.examine({
          purchase_id: this.$route.params.id,
          examine_details: data,
        })
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$router.push("/purchases-examine");
              } else if (
                response.data.error &&
                response.data.error.code &&
                response.data.error.code == "ERR427"
              ) {
                this.dateErrorData = response.data.data;
                this.dateErrorDialog = true;
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      } else {
        this.$store.dispatch("fullscreenLoadingStop");
        // this.$router.push("/purchases-examine");
      }
    },
    async Examine() {
      this.$store.dispatch("fullscreenLoading");
      await this.submitUploadImg();
      Purchases.examine({
        purchase_id: this.$route.params.id,
        status: 4,
      })
        .then(
          function (response) {
            // 完成
            if (response.data.status.isOK()) {
              this.$router.push("/purchases-examine");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    setQualifyReportImg(key, data) {
      this.$set(this.currentItem, key, data);
    },
    editDate() {
      this.$store.dispatch("fullscreenLoading");
      Purchases.editHopeDeliveryDate({
        id: this.purchase.id,
        hope_delivery_date: this.purchase.hope_delivery_date,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$store.dispatch("fullscreenLoadingStop");
              this.$snackbar.success(
                i18n.t("PurchasesDetail.Messages.saveSuccess")
              );
            } else {
              this.purchase.hope_delivery_date = this.oldHopeDeliveryDate;
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.purchase.hope_delivery_date = this.oldHopeDeliveryDate;
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    removeFromImages(i) {
      this.album.splice(i, 1);
      this.imgs_file.splice(i, 1);
    },
    async submitUploadImg() {
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }

      //提交图片集
      var purchase_img = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        let response = await Files.imagesUpload(
          this.imgs_file,
          false,
          "images",
            true
        );

        if (response.data.status.isOK()) {
          response.data.data.forEach((img) => purchase_img.push(img.img_name));
          Purchases.update({
            purchase_code: this.purchase.purchase_code,
            img: purchase_img,
          })
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        }
      }
    },
    saveExpress() {
      if (this.purchase.express_price < 0) {
        this.$snackbar.error(i18n.t("Order.messages.editExpressPriceError"));
        return;
      }
      Purchases.saveExpress(this.purchase.id, {
        id: this.purchase.id,
        express_price: this.purchase.express_price,
      }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.editExpressFlg = false;
              this.getPurchasesDetailsFromAPI();
            }
          }.bind(this)
      );
    },
  },

  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/purchases-examine/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.$route.params.id) {
          this.getPurchasesDetailsFromAPI();
        }
      },
    },
    purchase_details: {
      deep: true,
      handler() {
        var dayjs = require("dayjs");
        this.purchase_details.forEach((detail) => {
          //生产，过期日期联动
          // 联动互填逻辑暂存
          // if (detail.production_date && !detail.expired_date) {
          //   detail.expired_date = dayjs(detail.production_date)
          //     .add(Number(detail.bestbefore), "day")
          //     .format("YYYY-MM-DD");
          // } else if (!detail.production_date && detail.expired_date) {
          //   detail.production_date = dayjs(detail.expired_date)
          //     .subtract(Number(detail.bestbefore), "day")
          //     .format("YYYY-MM-DD");
          // }
          // if (detail.production_date_2 && !detail.expired_date_2) {
          //   detail.expired_date_2 = dayjs(detail.production_date_2)
          //     .add(Number(detail.bestbefore), "day")
          //     .format("YYYY-MM-DD");
          // } else if (!detail.production_date_2 && detail.expired_date_2) {
          //   detail.production_date_2 = dayjs(detail.expired_date_2)
          //     .subtract(Number(detail.bestbefore), "day")
          //     .format("YYYY-MM-DD");
          // }
          // if (detail.production_date_3 && !detail.expired_date_3) {
          //   detail.expired_date_3 = dayjs(detail.production_date_3)
          //     .add(Number(detail.bestbefore), "day")
          //     .format("YYYY-MM-DD");
          // } else if (!detail.production_date_3 && detail.expired_date_3) {
          //   detail.production_date_3 = dayjs(detail.expired_date_3)
          //     .subtract(Number(detail.bestbefore), "day")
          //     .format("YYYY-MM-DD");
          // }

          // 供应商发货数据整理
          if (detail.stock_in_details) {
            detail.stock_in_details.forEach((stockDetail) => {
              if (
                this.settings &&
                this.settings.product_date_setting &&
                Number(detail.bestbefore) &&
                stockDetail.production_date &&
                !stockDetail.expired_date
              ) {
                stockDetail.expired_date = dayjs(stockDetail.production_date)
                  .add(Number(detail.bestbefore), "day")
                  .format("YYYY-MM-DD");
              }
            });
          }

          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.bestbefore) &&
            detail.production_date &&
            !detail.expired_date
          ) {
            detail.expired_date = dayjs(detail.production_date)
              .add(Number(detail.bestbefore), "day")
              .format("YYYY-MM-DD");
          }
          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.bestbefore) &&
            detail.production_date_2 &&
            !detail.expired_date_2
          ) {
            detail.expired_date_2 = dayjs(detail.production_date_2)
              .add(Number(detail.bestbefore), "day")
              .format("YYYY-MM-DD");
          }
          if (
            this.settings &&
            this.settings.product_date_setting &&
            Number(detail.bestbefore) &&
            detail.production_date_3 &&
            !detail.expired_date_3
          ) {
            detail.expired_date_3 = dayjs(detail.production_date_3)
              .add(Number(detail.bestbefore), "day")
              .format("YYYY-MM-DD");
          }

          if (this.isExamine && this.settings.purchase_subtotal == 1) {
            if (detail.examine_num_edit != 0) {
              detail.price =
                Number(detail.total) / Number(detail.examine_num_edit);
              detail.price_2 = detail.examine_num_edit_2
                ? Number(detail.total_2) / Number(detail.examine_num_edit_2)
                : 0;
              detail.price_3 = detail.examine_num_edit_3
                ? Number(detail.total_3) / Number(detail.examine_num_edit_3)
                : 0;
            } else {
              detail.price = 0;
            }
          } else if (this.isExamine && this.settings.purchase_subtotal != 1) {
            detail.total = this.$numberFormatter.formatMoneyFloor(
              Number(detail.examine_num_edit) * Number(detail.price),
              2
            );
            detail.total_2 = this.$numberFormatter.formatMoneyFloor(
              Number(detail.examine_num_edit_2) * Number(detail.price_2),
              2
            );
            detail.total_3 = this.$numberFormatter.formatMoneyFloor(
              Number(detail.examine_num_edit_3) * Number(detail.price_3),
              2
            );
          }

          if (this.purchase.delivery_flg == 1 && this.purchase.delivery_date) {
            if (detail.stock_in_details) {
              detail.stock_in_details.forEach((stockDetail) => {
                stockDetail.total = this.$numberFormatter.formatMoneyFloor(
                  Number(stockDetail.examine_num_edit) *
                    Number(stockDetail.price),
                  2
                );
              });
            }
          }
        });
      },
    },
    currentItem: {
      deep: true,
      handler() {
        this.purchase_details.forEach((detail) => {
          if (detail.id == this.currentItem.id) {
            detail.qualify_report_img = this.currentItem.qualify_report_img
              ? this.currentItem.qualify_report_img
              : [];
            detail.qualify_report_img_2 = this.currentItem.qualify_report_img_2
              ? this.currentItem.qualify_report_img_2
              : [];
            detail.qualify_report_img_3 = this.currentItem.qualify_report_img_3
              ? this.currentItem.qualify_report_img_3
              : [];
          }
        });
      },
    },
    imgs_file: {
      deep: true,
      handler() {
        if (this.imgs_file.length) {
          if (this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.album = [];
            this.imgs_file = [];
          } else {
            this.album = [];
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = this.purchase.img ? this.purchase.img : [];
        }
      },
    },
  },
};
</script>